import { useState } from "react";
import { Gavel, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";
import { money } from "@/lib/format";

export const LateFeeButton = ({ onDone, variant = "outline" }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/late-fees/run");
      const total = data.details.reduce((s, d) => s + d.amount_cents, 0);
      toast.success(
        data.fees_assessed
          ? `Assessed ${data.fees_assessed} late fee${data.fees_assessed > 1 ? "s" : ""} (${money(total)})`
          : "No new late fees — everything is up to date",
        { description: `${data.loans_checked} open loan${data.loans_checked === 1 ? "" : "s"} checked` },
      );
      onDone?.(data);
    } catch (e) {
      toast.error(apiError(e).message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button variant={variant} onClick={run} disabled={busy} data-testid="run-late-fee-check-button">
      {busy ? <Loader2 className="animate-spin" /> : <Gavel />}
      Run late-fee check
    </Button>
  );
};
